import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import { IQueryParam } from '@interfaces/fast-report-params';

import { ResourceUrlHelper } from './resource-url-helper';

@Directive({
  selector: 'a[appResourceUrlHelper]',
})
export class AnchorResourceUrlHelperDirective extends ResourceUrlHelper implements OnChanges {
  @HostBinding('href') override url: string;
  @Input() queryParams: IQueryParam[];
  @Input() href: string;

  ngOnChanges(): void {
    this.url = this.constructUrl(this.href, this.queryParams);
  }
}
